module.exports = __webpack_public_path__ + "static/blue-dragon-lightning-e01e60bd4bff88d653fdccda18d848fc.jpg";